<template>
  <a
      v-if="showListYourProperty"
      href="https://docs.google.com/forms/d/e/1FAIpQLSfXu_LlDgYTat2Gcv57XXe3MF-UOghoU4Phvno4jR1HJCrbAw/viewform"
      target="_blank"
      class="list-your-property"
  >
    {{$t('List your property')}}
  </a>
</template>

<script lang="ts" setup>
import { useRoute } from "vue-router";
const route = useRoute();

const availableRoutes = ['index__', 'hotels-city__', 'experiences-city__']
const showListYourProperty = computed(() => {
  let showForm = false
  availableRoutes.forEach((r) => {
    if ((route?.name as string)?.includes(r)) {
      showForm = true
    }
  });
  return showForm
})
</script>

<style lang="scss">
.list-your-property {
  font-family: Albert Sans;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0;
  color: var(--blue);
}
</style>
